<div class="executed-form">
  <!-- REPO -->

  <ng-container *ngIf="type === 'repo'">
    <div
      class="executed-form__repo-yes-no client-executed-form-yes-no bold-gray-yes-no"
      [class.mb-0]="!repoAdjustment.repoByInpress"
    >
      <img
        [class.red-marker--readonly]="readOnly"
        class="red-marker"
        src="/assets/markers/Rood.png"
        width="22"
        height="32"
      />

      <p *ngIf="readOnly" class="title title--l">Weghalen aangevraagd</p>

      <yes-no
        *ngIf="!readOnly"
        [flexRow]="false"
        [yesValue]="'Weghalen aub'"
        [noValue]="'Opdracht is reeds weggehaald'"
        [nullIsFalse]="true"
        [nullable]="false"
        [neverShowExtraInstructions]="true"
        [value]="repoAdjustment.repoByInpress"
        [disabled]="readOnly"
        [disabledYes]="readOnly"
        [disabledNo]="readOnly"
        (answer)="repoByInpressChanged($event)"
      ></yes-no>
    </div>

    <textarea-input
      *ngIf="
        !readOnly ||
        (adjustment.extraInfoAdjustment != null &&
          adjustment.extraInfoAdjustment != '')
      "
      class="executed-form__repo-text"
      [class.executed-form__repo-text--readonly]="readOnly"
      [title]="'Opmerkingen van de klant:'"
      [minHeight]="200"
      [placeholder]="
        readOnly
          ? ''
          : (EX_EDIT_ADJUSTMENT_KEY.EXTRA_INFO_ADJUSTMENT_PLACEHOLDER
            | exEditAdjustmentString : false : adjustment)
      "
      [initContent]="adjustment.extraInfoAdjustment"
      (answer)="adjustment.extraInfoAdjustment = $event; emitSave()"
      [showOnly]="true"
      [client]="true"
      [disabled]="readOnly"
    ></textarea-input>

    <ng-container
      *ngIf="
        arrows != null ||
        secondBoardPresent ||
        otherOrderPlacementInfoDisplay?.length > 0
      "
    >
      <ul class="inpress-ul">
        <li *ngIf="arrows != null">
          <div class="inline-table">
            <div class="strong">Pijltjes</div>

            <div *ngIf="arrows.amountArrowsLeft > 0">
              Aantal links: {{ arrows.amountArrowsLeft }}
            </div>

            <div *ngIf="arrows.amountArrowsRight > 0">
              Aantal rechts: {{ arrows.amountArrowsRight }}
            </div>
          </div>
        </li>

        <li *ngIf="secondBoardPresent">
          <span class="strong">Tweede bord op hetzelfde pand</span>
        </li>

        <li *ngIf="otherOrderPlacementInfoDisplay?.length > 0">
          <div class="inline-table">
            <div class="strong">Andere bestelling</div>

            <div class="preserve-new-line">
              {{ otherOrderPlacementInfoDisplay }}
            </div>
          </div>
        </li>
      </ul>
    </ng-container>
  </ng-container>

  <!-- ADJUSTMENT -->

  <div *ngIf="type === 'adjustment'" class="executed-form__adjustment-text">
    <img
      [class.blue-marker--readonly]="readOnly"
      class="blue-marker"
      src="/assets/markers/Blauw.png"
      width="22"
      height="32"
    />

    <textarea-input
      class="executed-form__adjustment-text"
      [class.executed-form__adjustment-text--readonly]="readOnly"
      [title]="readOnly ? 'Aanpassing aangevraagd' : 'Aanpassing aub'"
      [minHeight]="200"
      [placeholder]="
        readOnly
          ? ''
          : (EX_EDIT_ADJUSTMENT_KEY.EXTRA_INFO_ADJUSTMENT_PLACEHOLDER
            | exEditAdjustmentString : false : adjustment)
      "
      [initContent]="adjustment.extraInfoAdjustment"
      (answer)="adjustment.extraInfoAdjustment = $event; emitSave()"
      [showOnly]="true"
      [client]="true"
      [disabled]="readOnly"
    ></textarea-input>

    <br />

    <file-picker
      [hideUpload]="false"
      [title]="'Laad hier uw afbeeldingen op.'"
      [uploadButtonLabel]="'Upload'"
      [inputProjectPlacement]="adjustment.projectPlacement"
      [formSection]="'adjustmentExternal'"
      [offlineUpload]="offlineUpload"
    ></file-picker>
  </div>

  <!-- SOLD RENTED -->

  <ng-container *ngIf="type === 'soldrented'">
    <div
      class="executed-form__sold-rented-sticker client-executed-form-yes-no bold-gray-yes-no"
      [class.mb-0]="!soldRentedAdjustment.installByInpress"
    >
      <img
        [class.yellow-marker--readonly]="readOnly"
        class="yellow-marker"
        src="/assets/markers/Geel.png"
        width="22"
        height="32"
      />

      <yes-no
        [yesValue]="'Sticker aanbrengen'"
        [noValue]="'Heb zelf een sticker aangebracht'"
        [nullIsFalse]="false"
        [neverShowExtraInstructions]="true"
        [value]="soldRentedAdjustment.installByInpress"
        [flexRow]="false"
        [nullable]="false"
        [disabled]="readOnly || disableInstallByInpress"
        [disabledYes]="readOnly"
        [disabledNo]="readOnly"
        (answer)="installByInpressChanged($event)"
      ></yes-no>

      <ng-container *ngIf="soldRentedAdjustment.installByInpress">
        <ng-container *ngIf="!!ipBoard; else stickerOptions">
          <sold-rented-sticker-select
            [ipBoard]="ipBoard"
            [ipBoardPart]="ipBoard.boardPart"
            [soldRented]="soldRentedAdjustment"
            [readOnly]="readOnly"
            (save)="setSignSticker()"
          >
          </sold-rented-sticker-select>
        </ng-container>

        <ng-template #stickerOptions>
          <div class="sold-rented__row">
            <div>
              <div class="title">Kies hier de gewenste sticker</div>

              <mat-form-field appearance="outline">
                <mat-select
                  matInput
                  placeholder="Maak een keuze"
                  [(ngModel)]="selectedSticker"
                  [compareWith]="compareOptions"
                  [disabled]="readOnly"
                  (selectionChange)="selectedStickerOptionChanged()"
                >
                  <mat-option
                    *ngFor="let option of STICKER_OPTIONS"
                    [value]="option"
                  >
                    {{ option.label }}
                  </mat-option>
                </mat-select>
              </mat-form-field>
            </div>

            <div
              *ngIf="selectedSticker?.id === OTHER_STICKER_ID"
              class="other-value-input top-margin"
            >
              <mat-form-field appearance="outline">
                <input
                  matInput
                  [disabled]="readOnly"
                  placeholder="Gewenste sticker"
                  [(ngModel)]="adjustment.otherSticker"
                />
              </mat-form-field>
            </div>
          </div>
        </ng-template>
      </ng-container>
    </div>

    <textarea-input
      *ngIf="
        soldRentedAdjustment.installByInpress &&
        (!readOnly ||
          (adjustment.extraInfoAdjustment != null &&
            adjustment.extraInfoAdjustment != ''))
      "
      class="executed-form__sold-rented-text"
      [class.executed-form__repo-text--readonly]="readOnly"
      [title]="'Opmerkingen van de klant:'"
      [minHeight]="200"
      [placeholder]="
        readOnly
          ? ''
          : (EX_EDIT_ADJUSTMENT_KEY.EXTRA_INFO_ADJUSTMENT_PLACEHOLDER
            | exEditAdjustmentString : false : adjustment)
      "
      [initContent]="adjustment.extraInfoAdjustment"
      (answer)="adjustment.extraInfoAdjustment = $event; emitSave()"
      [showOnly]="true"
      [client]="true"
      [disabled]="readOnly"
    ></textarea-input>

    <ul *ngIf="secondBoardPresent" class="inpress-ul">
      <li>
        <span class="strong"> Tweede bord op hetzelfde pand </span>
      </li>
    </ul>

    <br />
  </ng-container>

  <ng-container *ngIf="isExecuted">
    <div>
      <span class="strong">Gewenste uitvoeringsdatum: </span>
      {{
        adjustment.projectPlacement?.placementEarliestDate
          | formatASAPDate : adjustment.projectPlacement?.placeASAP
      }}
    </div>
  </ng-container>

  <client-adjustment-form-shared
    *ngIf="
      (type === 'adjustment' ||
        repoAdjustment.repoByInpress ||
        soldRentedAdjustment.installByInpress) &&
      !isExecuted
    "
    [readOnly]="readOnly"
    [adjustment]="adjustment"
    [projectContacts]="projectContacts"
    [projectHasIPBoards]="projectHasIPBoards"
    [showAppointmentWarning]="showAppointmentWarning"
    [minDate]="minDate"
    (save)="emitSave()"
  ></client-adjustment-form-shared>

  <ng-container *ngIf="!readOnly">
    <client-sub-project-on-hold-collapse
      *ngIf="adjustment.putOnHold != null"
      [subProject]="adjustment"
      [onHoldCollapsed]="!adjustment.onHold"
      (save)="save.emit()"
    ></client-sub-project-on-hold-collapse>

    <client-adjustment-design-collapse
      *ngIf="adjustment.needsDesign"
      [projectId]="projectId"
      [ipBoard]="ipBoard"
      [projectContacts]="projectContacts"
      [adjustment]="adjustment"
      [designCollapsed]="adjustment.designFinished"
      (save)="save.emit()"
    ></client-adjustment-design-collapse>
  </ng-container>
</div>
